export default __webpack_public_path__ + "static/media/Matthew.cc3490ac.png";